import { error, success } from '@innovyze/stylovyze';
import { t } from 'i18next';
import { AnyAction } from 'redux';

const TERMINAL_STATUSES = new Set([
	'risk-calc-complete',
	'risk-calc-failed',
	'risk-calc-cancelled',
]);

// The toast for a run finishing, using the same rules as
// RiskManagement.page's updateStatus: only on a change into a terminal status
// from a non-terminal one (not on initial load, and not terminal → terminal).
// Model-agnostic, so it can run when no risk page is mounted.
export const runStatusToastAction = (
	status: string | undefined,
	previousStatus: string | undefined,
): AnyAction | undefined => {
	if (!status || !TERMINAL_STATUSES.has(status)) return undefined;
	if (
		previousStatus === undefined ||
		previousStatus === null ||
		TERMINAL_STATUSES.has(previousStatus)
	)
		return undefined;
	if (status === 'risk-calc-complete')
		return success(t('Risk calculation completed'));
	if (status === 'risk-calc-cancelled')
		return error(t('Risk calculation cancelled'));
	return error(t('Risk calculation failed'));
};
